import { FC } from 'react';
import { Link } from 'react-router-dom';

import SidebarSubmenu from '../sidebar-submenu/SubMenu';

import { useActiveSection } from '@widgets/sidebar/lib';

import { ISidebarSection } from '@widgets/sidebar/Sidebar.types';

import { cn } from '@utils/style.util';

import { classes } from './SidebarItem.tailwind';

type PropsType = ISidebarSection & {
  parentTitle?: string;
};

const SidebarItem: FC<PropsType> = ({ Icon, title, path, subItems, parentTitle }) => {
  const isActive = useActiveSection(path ?? '');

  const isInvoiceGeneratorChild =
    parentTitle === 'Invoice Generator' && (title === 'Employees' || title === 'Customers');
  const dataId = isInvoiceGeneratorChild
    ? `section-${title.replace(/\s/g, '')}-generator`
    : `section-${title.replace(/\s/g, '')}`;

  return (
    <div className="relative group" data-id={dataId}>
      {path ? (
        <Link to={path} className={cn(classes.container, subItems && 'nested-section peer', isActive && 'bg-platinum')}>
          <Icon />
          <p>{title}</p>
        </Link>
      ) : (
        <span className={cn(classes.container, subItems && 'nested-section peer')}>
          <Icon />
          <p>{title}</p>
        </span>
      )}

      {subItems ? <SidebarSubmenu items={subItems} parentTitle={title} /> : null}
    </div>
  );
};

export default SidebarItem;
